import {useCallback, useState} from "react";
import AsyncSelect from "react-select/async";
import {toast} from "react-toastify";
import ApiRoute from "../../../helper/api";
import Modal from "../../Utilities/Modal";
import BrandSelect2 from "../../Product/Category/BrandSelect2";

export default function SyncPriceRulesWithBrand({closeModal}) {
    const [rule, setRule] = useState(null);
    const [brand, setBrand] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const loadRules = useCallback(async (inputValue = '') => {
        const res = await ApiRoute.price.rule.index.fn({page: 1}, {
            quick_search: {
                term: inputValue,
                by: 'title',
            },
        });
        const items = res?.results?.data || res?.results || [];
        return Array.isArray(items) ? items.map((item) => ({
            value: item._id,
            label: item.title,
        })) : [];
    }, []);

    async function handleSubmit() {
        if (!rule || !brand?.value) {
            toast.error('قانون قیمت و برند را انتخاب کنید.');
            return;
        }

        setIsSubmitting(true);
        const res = await ApiRoute.price.rule.syncRulesWithProductsByBrand.fn(rule.value, {
            brand_slug: brand.value,
        });
        setIsSubmitting(false);

        if (res?.status_code >= 200 && res?.status_code < 300) {
            toast.success('درخواست سینک قوانین با موفقیت ارسال شد.');
            closeModal();
        } else {
            toast.error(res?.message || 'ارسال درخواست سینک قوانین ناموفق بود.');
        }
    }

    return (
        <Modal isOpen={true} onClose={closeModal}>
            <div className="page-title mb-3">
                <span className="inline-block bg-white text-xs text-purple-1 pl-3">سینک قوانین بر اساس برند</span>
            </div>

            <div className="form grid-form grid grid-cols-1 text-xs gap-3 my-6">
                <label>
                    <span className="block">قانون قیمت</span>
                    <AsyncSelect
                        className="mt-1"
                        value={rule}
                        onChange={setRule}
                        loadOptions={loadRules}
                        defaultOptions
                        cacheOptions
                        isClearable={true}
                        isSearchable={true}
                        placeholder="انتخاب قانون قیمت"
                        noOptionsMessage={() => 'موردی یافت نشد'}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                            menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                            }),
                        }}
                    />
                </label>

                <label>
                    <span className="block">برند</span>
                    <BrandSelect2
                        multiple={false}
                        defaultValue={[]}
                        assignItem={setBrand}
                        placeholder="انتخاب برند"
                    />
                </label>
            </div>

            <div className="flex justify-end mt-4">
                <button
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    className="btn-purple px-5 py-2 disabled:opacity-50"
                >
                    {isSubmitting ? 'در حال ارسال...' : 'سینک'}
                </button>
            </div>
        </Modal>
    );
}
